import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";

const DUMMY_REASONS = [
  { ID: 1, Code: "DUP", Description: "Duplicate Block" },
  { ID: 2, Code: "GCH", Description: "Guest Changed Plans" },
  { ID: 3, Code: "ERR", Description: "Created in Error" },
  { ID: 4, Code: "NOP", Description: "No Pickup" },
  { ID: 5, Code: "OTH", Description: "Other Reason" },
];

const CancelReasonPopup = ({ show, title, onClose, onSelect }) => {
  const [searchText, setSearchText] = useState("");
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (!show) return undefined;
    setSearchText("");
    setSelectedId(null);

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        event.stopImmediatePropagation();
        onClose();
      }
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [show, onClose]);

  if (!show) return null;

  const query = searchText.trim().toLowerCase();
  const filteredReasons = DUMMY_REASONS.filter((reason) =>
    `${reason.Code} ${reason.Description}`.toLowerCase().includes(query),
  );
  const selectedReason = DUMMY_REASONS.find((reason) => reason.ID === selectedId);

  return (
    <div
      className="modal fade show d-block cancel-reason-modal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cancelReasonPopupTitle"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header cancel-reason-header">
            <h5 id="cancelReasonPopupTitle" className="modal-title">{title}</h5>
            <button type="button" className="btn-close btn-close-white" aria-label="Close" onClick={onClose} />
          </div>

          <div className="modal-body">
            <div className="input-group input-group-sm cancel-reason-search">
              <input
                type="search"
                className="form-control"
                placeholder="Search by code or description"
                value={searchText}
                onChange={(event) => setSearchText(event.target.value)}
                autoFocus
              />
              <span className="input-group-text"><Search aria-hidden="true" /></span>
            </div>

            <div className="table-responsive cancel-reason-table-wrap">
              <table className="table table-sm table-hover mb-0">
                <thead>
                  <tr><th>Code</th><th>Description</th></tr>
                </thead>
                <tbody>
                  {filteredReasons.length ? filteredReasons.map((reason) => (
                    <tr
                      key={reason.ID}
                      className={selectedId === reason.ID ? "cancel-reason-selected" : ""}
                      onClick={() => setSelectedId(reason.ID)}
                      onDoubleClick={() => onSelect(reason)}
                    >
                      <td>{reason.Code}</td>
                      <td>{reason.Description}</td>
                    </tr>
                  )) : (
                    <tr><td colSpan="2" className="text-center py-4">No matching reason found.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-light btn-sm" onClick={onClose}>Cancel</button>
            <button type="button" className="btn btn-primary btn-sm" disabled={!selectedReason} onClick={() => onSelect(selectedReason)}>Select</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelReasonPopup;
